import BaseModal from "./base_modal"
import { fetchWithCsrf } from "../util"

export default class TermsOfServiceModal extends BaseModal {
  constructor(updateUrl) {
    super()
    this.updateUrl = updateUrl
  }

  modalId() {
    return "terms-of-service-modal"
  }

  bindEvents() {
    const modal = this.modalElement()

    modal.querySelectorAll("[data-modal-dismiss]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault()
        this.acceptAndDismiss()
      })
    })

    const modalWrapper = modal.querySelector(".modal-wrapper")
    if (modalWrapper) {
      modalWrapper.addEventListener("click", (event) => {
        event.stopPropagation()
      })
    }
  }

  async acceptAndDismiss() {
    await fetchWithCsrf(this.updateUrl, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user: { platform_privacy_policy_accepted: true } })
    })
    this.dismiss()
  }

  modalHTML() {
    return `
      <div id="terms-of-service-modal"
           class="fixed inset-0 z-50 flex items-center justify-center bg-darkblue/60"
           aria-hidden="false">
        <div class="modal-wrapper relative">
          <button type="button"
                  data-modal-dismiss
                  class="modal-close-btn absolute top-4 right-4 z-10">
            <i class="icon-close text-seasalt-500 text-2xl"></i>
            <span class="sr-only">Close modal</span>
          </button>

          <div class="modal-container modal-container--md">
            <div class="modal-content modal-section ui-gap-lg">
              <div class="flex flex-col ui-gap-xs leading-20">
                <p class="font-semibold leading-20">
                  We're making things simpler for everyone! 👋
                </p>
                <p class="leading-20">
                  We've combined all our User Terms for Ambassadors, Admins, and Prospect Users into one easy-to-read document.
                  You can review it following the link.
                </p>
              </div>

              <div class="flex flex-col ui-gap-xs">
                <div class="flex flex-col gap-5">
                  <p class="font-semibold leading-20">
                    What happens next? 🚀
                  </p>
                  <p class="leading-20">
                    By continuing to enjoy our platform, you're all set with these updates.
                    No action needed unless you want to take a peek at the changes!
                  </p>
                </div>

                <p class="leading-20">
                  If you have any questions – we're always here to help!
                </p>
              </div>
            </div>

            <div class="modal-section">
              <button type="button"
                data-modal-dismiss
                class="btn-orange-md w-200! mx-auto">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    `
  }
}
